import { Box, Link, Tooltip, Typography } from '@mui/material';

import { Iconify } from 'src/components/iconify';

type SectionHeaderProps = {
  title: string;
  tooltipTitle?: string;
  helpUrl?: string;
};

export function SectionHeader({ title, tooltipTitle, helpUrl }: SectionHeaderProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
      <Typography variant="subtitle2" color="text.primary">
        {title}
      </Typography>
      {tooltipTitle && helpUrl && (
        <Tooltip title={tooltipTitle} arrow>
          <Link
            href={helpUrl}
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
            underline="none"
            sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
          >
            <Iconify icon="mdi:information-outline" width={18} height={18} />
          </Link>
        </Tooltip>
      )}
    </Box>
  );
}
